<template>
    <vue-element-loading
        :active="status"
        :delay="0"
        :is-full-screen="fullPage"
        :background-color="backgroundColor"
        :color="color"
    />
</template>

<script>
import {UI_COLORS} from '@/utils/ui-colors';

export default {
    name: "loading",
    props: {
        status: {
            type: Boolean,
            required: true,
            default: true
        },
        fullPage: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: '#FFFFFF'
        },
        color: {
            type: String,
            default: UI_COLORS.text.secondary
        },
    }
}
</script>
